import { name } from "dayjs/locale/ar-iq";

export const NOTIFICATIONS = `/v2/ministry/notifications`;
export const SEND_NOTIFICATION = `/v2/ministry/send-notification`;
export const NOTIFICATION_BY_ID = (id) => `/v2/ministry/notifications/${id}`;
export const REPORT_VIEW = (params) =>
  `/v2/ministry/reports/${params.slug}/${params.id}`;
export const QUESTIONS = `/v2/ministry/faqs`;
export const QUESTION_BY_ID = (id) => `/v2/ministry/faqs/${id}`;
export const FAQ_CATEGORIES = `/v2/ministry/category-faqs`;
export const FAQ_CATEGORY_BY_ID = (id) => `/v2/ministry/category-faqs/${id}`;
export const FEEDBACK = "v2/ministry/requests/set-feedback";
export const VALIDATE = "v2/ministry/requests/set-validated";
export const REQUEST_BY_ID = (id) => `v2/ministry/requests/est-ngo/${id}`;
export const CHANGE_STATUS = (id) => `v2/ministry/requests/change-status/${id}`;
export const ROLE_BY_ID = (id) => `v2/ministry/roles/${id}`;

export const ROLE = `v2/ministry/roles`;
export const TRANSICTION_ROLE = `v2/ministry/transaction-request-roles`;
export const TRANSICTION_ROLE_BY_ID = (id) => `v2/ministry/transaction-request-roles/${id}`;
export const INSTRUCTIONS = "v2/ministry/instructions";
export const HINTS_BY_SLUG = (slug) => `v2/ministry/hints/${slug}`;
export const HINTS = `v2/ministry/hints`;
export const INSTRUCTION_BY_ID = (id) => `v2/ministry/instructions/${id}`;
export const HOLIDAYS = "v2/ministry/annual-holidays";
export const HOLIDAYS_BY_ID = (id) => `v2/ministry/annual-holidays/${id}`;
export const HOLIDAYS_BY_NAME = (name) => `v2/ministry/annual-holidays?name=${name}`;
export const CIRCULARS = `v2/ministry/circulars`;
export const CIRCULAR_BY_ID = (id) => `v2/ministry/circulars/${id}`;
export const EVENTS = `v2/ministry/events`;
export const EVENT_BY_ID = (id) => `v2/ministry/events/${id}`;
export const NGOS_SEARCH_ENGINE = (key) =>
  `v2/ministry/search-engine/ngos?search=${key}`;
export const INCENTIVES = `v2/ministry/incentives`;
export const INCENTIVE_BY_ID = (id) => `v2/ministry/incentives/${id}`;
export const CONFIRM_CAMPAIGN = (id) => `v2/ministry/campaign-confirm/${id}`;
export const FEATURE_CAMPAIGN = (id) => `v2/ministry/campaign-featured/${id}`;

export const SLIDES = "v2/ministry/slide-images";
export const SLIDE_BY_ID = (id) => `v2/ministry/slide-images/${id}`;

export const NGOS = "v2/ministry/immediate-ngos";
export const NGO_BY_ID = (id) => `v2/ministry/immediate-ngos/${id}`;

// mediation-requestes
export const MEDIATION_REQUEST = (id) =>
  `v2/ministry/files-qrs/get-file-qr-logs/${id}`;
export const MEDIATION_REQUEST_BY_ID = (id) =>
  `v2/ministry/files-qrs/frozen-file/${id}`;

export const TYPES = "v2/ministry/regulation-types";
export const TYPE_BY_ID = (id) => `v2/ministry/regulation-types/${id}`;

export const REGULATIONS = `v2/ministry/regulations`;
export const REGUALTION_BY_ID = (id) => `v2/ministry/regulations/${id}`;
export const NGO_VALIDATE = (id) => `v2/ministry/ngo-completion/${id}`;
export const ACCEPT_NAME = (id) => `v2/ministry/est/assign-ngo-name/${id}`;

export const FORM_BY_ID = (id) =>
  `/v2/ministry/custom/reports/consultation-surveys/${id}`;
  //Transaction
  
export const TRANSACTION_BY_ID = (id) => `v2/ministry/transaction-requests/${id}`;
export const REASIGN_TRANSACTION_BY_ID = (id) => `v2/ministry/reassign-ministry-user/${id}`;
export const TRANSACTION_ACTIONS_BY_ID = (id) => `v2/ministry/action-types/${id}`;
export const TRANSACTION_TYPE_BY_ID = (id) => `v2/ministry/transaction-types/${id}`;
export const UPDATE_USER_AVAILABILITY_BY_ID = (id) => `v2/ministry/update-user-availability/${id}`;
export const  CURRENT_STAGE = "v2/establishment/change-current-stage-number";